import { getAngleInDeg } from '@wix/wow-utils';
import { getMouseTransitionEasing } from '../../../utils/animationsUtils';
export const name = 'SpinMouse';
export const properties = {
    schema: {},
};
export function animate(_kit, elements, _duration, _delay, { inverted = false, axis = 'both', transitionDuration, transitionEasing = 'linear', } = {}) {
    const element = elements[0];
    const invert = inverted ? -1 : 1;
    if (transitionDuration) {
        element.style.transition = `transform ${transitionDuration}ms ${getMouseTransitionEasing(transitionEasing)}`;
    }
    return {
        progress({ x: progressX, y: progressY }) {
            const rotation = getAngleInDeg([0.5, 0.5], [
                axis === 'vertical' ? 0 : progressX,
                axis === 'horizontal' ? 0 : progressY,
            ], 90) * invert;
            const transform = `rotate(calc(${rotation}deg + var(--comp-rotate-z)deg)`;
            element.style.transform = transform;
        },
        kill() {
            element.style.transform = '';
            element.style.transition = '';
        },
    };
}
//# sourceMappingURL=spinMouse.js.map